module.exports = __webpack_public_path__ + "img/ditan_xc6.0a908429.jpg";